<template>
  <div>
    <div class="container">
      <div class="row">
	<div class="col-12">
	  <div class="products-title">
	    Activation Code List
	  </div>
	  <div class="d-flex align-items-center justify-content-center">
	    <EasyDataTable
	      table-class-name="custom"
	      v-model:server-options="serverOptions"
	      :server-items-length="serverItemsLength"
	      :loading="loading"
	      :headers="headers"
	      :items="items"
	      :body-row-class-name="bodyRowClassNameFunction"
	      :rowsItems=[5,10,20]
	      :mustSort=true
	      @click-row="selectActivationCode"
	      style="width: 100%;"
	      border-cell
	    />
	  </div>
	</div>
      </div>
    </div>
    <div class="container mt-4 mb-4">
      <form>
	<div class="card">
	  <div class="card-header text-left">Activation Code Status</div>
          <div class="card-body">
            <div class="form-group row">
              <div class="col-sm-12 form-inline">
		<div class="container-fluid">
                  <div class="row">
                    <div class="col-7">
                      <div class="form-group">　</div>
                    </div>
                    <div class="col-5">
                      <div class="d-flex flex-row bd-highlight justify-content-around">
			<div class="p-2 bd-highlight">Max Installs</div>
			<div class="p-2 bd-highlight"><input type="number" class="form-control" id="dateinstall1" name="dateinstall1" placeholder="" size="8" maxlength="" v-model="max_installs"></div>
			<div class="p-2 bd-highlight"><div class="centerbox"><button type="button" class="bluebtn1" @click="updateMaxInstalls">Update</button></div></div>
                      </div>
                    </div>
		  </div>
		</div>
              </div>
              <div class="form-group row">
		<div class="d-flex align-items-center justify-content-center">
		  <EasyDataTable
		    table-class-name="custom"
		    v-model:server-options="serverOptions2"
		    :server-items-length="serverItemsLength2"
		    :loading="loading2"
		    :headers="headers2"
		    :items="items2"
		    :rowsItems=[5,10,20]
		    :mustSort=true
		    style="width: 100%;"
		    border-cell
		    alternating
	    />
		</div>
              </div>
            </div>
	  </div>
	</div>
      </form>
    </div>
    <p class="linespace20"></p>
    <div class="container">
      <div class="text-right">
	<router-link to="./searchactivation.html">
	  <div class="greenbtnM">Close</div>
	</router-link>
      </div>
    </div>
    <p class="linespace20"></p>
  </div>

  <ErrorDialog />
</template>

<script setup>
import { ref, computed, watch } from 'vue';
import router from '../router';
import { checkMaintenance, getProductList, getSoftwareTypeList, getTargetOSList, getVersionInfo, addVersionInfo, updateVersionInfo, deleteVersionInfo, checkVersion, searchActivationCode, getActivationHistory, updateMaxInstallCount } from '../server';
import { error } from './ErrorDialog.vue';

checkMaintenance();

const headers = [
    {
	text: 'Activation Code',
	value: 'activation_code',
	sortable: true
    },
    {
	text: 'Product Name',
	value: 'product_name',
	sortable: true
    },
    {
	text: 'Owner',
	value: 'mail_address',
	sortable: true
    },
    {
	text: 'Date of Issue (JST)',
	value: 'create_date',
	sortable: true
    },
    {
	text: 'Num Installs',
	value: 'install_count',
	sortable: true
    },
    {
	text: 'Max Installs',
	value: 'maximum_install_limit'
    },
    {
	text: 'Date of First Install (JST)',
	value: 'first_install_date',
	sortable: true
    }
];

const items = ref([]);

const loading = ref(false);
const serverItemsLength = ref(0);
const serverOptions = ref({
    page: 1,
    rowsPerPage: 5,
    sortBy: 'activation_code',
    sortType: 'asc'
});

const headers2 = [
    {
	text: 'Activation Date (JST)',
	value: 'activation_date',
	sortable: true
    },
    {
	text: 'E-mail address',
	value: 'email'
    },
    {
	text: 'Lang code',
	value: 'lang'
    }
];

const items2 = ref([]);

const loading2 = ref(false);
const serverItemsLength2 = ref(0);
const serverOptions2 = ref({
    page: 1,
    rowsPerPage: 5,
    sortBy: 'activation_date',
    sortType: 'asc'
});

const loadFromServer = async() => {
    loading.value = true;
    try {
	let res = await searchActivationCode(router.currentRoute.value.query,serverOptions.value);
	items.value = res.serverCurrentPageItems;
	serverItemsLength.value = res.serverTotalItemsLength;
    }
    catch(e) {
	console.log(e)
    }
    finally {
	loading.value = false;
    }
};

loadFromServer();

watch(serverOptions, (value) => {loadFromServer(); }, { deep: true });

const activation_code = ref('');

const selectActivationCode = async (data) => {
    max_installs.value = data.maximum_install_limit;
    activation_code.value = data.activation_code;
    await loadStatusFromServer();
};

const loadStatusFromServer = async() => {
    loading2.value = true;
    try {
	let res = await getActivationHistory({activation_code:activation_code.value}, serverOptions2.value);
	items2.value = res.serverCurrentPageItems;
	serverItemsLength2.value = res.serverTotalItemsLength;
    }
    catch(e) {
	console.log(e)
    }
    finally {
	loading2.value = false;
    }
};

watch(serverOptions2, (value) => {loadStatusFromServer(); }, { deep: true });

const max_installs = ref('');

const updateMaxInstalls = async () => {
    if (max_installs.value < 0) {
	error('Max installs is negative');
	return;
    }
    try {
	await updateMaxInstallCount(activation_code.value, max_installs.value);
    }
    catch(e) {
	console.log(e)
    }
    await loadFromServer();
};

const bodyRowClassNameFunction = (item, index) => {
  let result = 'odd-row';
  if (item.activation_code == activation_code.value) {
    result = 'select-row';
  }
  return result;
};

</script>

<style scoped>
.app {
    font-size: 40px;
    color: blue;
}
.select-row {
  --easy-table-body-row-background-color: #f56c6c;
}
.odd-row {
  --easy-table-body-row-background-color: #ffffff;
}
.custom {
    --easy-table-header-background-color: #9df5bc;
}
</style>
